export const MENU_ITEMS = [
  {
    title: 'admin.catalog'
  },
  {
    routerLink: 'page-list',
    title: 'admin.pages',
    icon: 'icon-doc'
  },
  // {
  //   routerLink: 'category-list',
  //   title: 'admin.categories',
  //   icon: 'icon-organization'
  // },
  {
    routerLink: 'banner-list',
    title: 'admin.banners',
    icon: 'icon-picture'
  },
  {
    routerLink: 'expertise-list',
    title: 'admin.expertises',
    icon: 'icon-grid'
  },
  {
    routerLink: 'network-list',
    title: 'admin.networks',
    icon: 'icon-globe-alt'
  },
  {
    routerLink: 'strength-list',
    title: 'admin.strengths',
    icon: 'icon-rocket'
  },
  {
    routerLink: 'job-list',
    title: 'admin.jobs',
    icon: 'icon-briefcase'
  },
  {
    routerLink: 'offer-list',
    title: 'admin.offers',
    icon: 'icon-present'
  },
  {
    routerLink: 'location-list',
    title: 'admin.locations',
    icon: 'icon-location-pin'
  },
  {
    routerLink: 'menu-list',
    title: 'admin.menus',
    icon: 'icon-menu'
  }
  // {
  //   title: 'admin.system'
  // },
  // {
  //   routerLink: 'user-list',
  //   title: 'admin.users',
  //   icon: 'icon-graduation'
  // }
]


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/admin.menu-items.ts